var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 6.77977C8.84925 6.77977 10.3484 5.28065 10.3484 3.43139C10.3484 1.58213 8.84925 0.0830078 6.99999 0.0830078C5.15073 0.0830078 3.65161 1.58213 3.65161 3.43139C3.65161 5.28065 5.15073 6.77977 6.99999 6.77977Z",
    fill: "#A8ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19287 14.0831C1.19287 10.876 3.79281 8.27588 6.99993 8.27588C10.2071 8.27588 12.8071 10.876 12.8071 14.0831H1.19287Z",
    fill: "#A8ADB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.0830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.b3d8ea5cc38376c0f222a8c5b9d648fa.svg";
export { ForwardRef as ReactComponent };